import vtkBoundingBox from './BoundingBox';
import vtkBox from './Box';
import vtkCell from './Cell';
import vtkCone from './Cone';
import vtkCylinder from './Cylinder';
import vtkDataSet from './DataSet';
import vtkDataSetAttributes from './DataSetAttributes';
import vtkITKHelper from './ITKHelper';
import vtkImageData from './ImageData';
import vtkImplicitBoolean from './ImplicitBoolean';
import vtkLine from './Line';
import vtkMolecule from './Molecule';
import vtkPiecewiseFunction from './PiecewiseFunction';
import vtkPlane from './Plane';
import vtkPointSet from './PointSet';
import vtkPolyData from './PolyData';
import vtkSphere from './Sphere';
import vtkStructuredData from './StructuredData';
import vtkTriangle from './Triangle';

export default {
  vtkBoundingBox,
  vtkBox,
  vtkCell,
  vtkCone,
  vtkCylinder,
  vtkDataSet,
  vtkDataSetAttributes,
  vtkITKHelper,
  vtkImageData,
  vtkImplicitBoolean,
  vtkLine,
  vtkMolecule,
  vtkPiecewiseFunction,
  vtkPlane,
  vtkPointSet,
  vtkPolyData,
  vtkSphere,
  vtkStructuredData,
  vtkTriangle,
};
